<template>
  <div id="root">
    <RecruitmentDepthChart />
  </div>
</template>
<script>

import RecruitmentDepthChart from '../../components/RecruitmentDepthChart/RecruitmentDepthChart.vue';

export default {
    components: {
        RecruitmentDepthChart
    }
};
</script>
